import React from 'react';
import PropTypes from 'prop-types';
import Quagga from 'quagga';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

export class Scanner extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onDetected = this
            .onDetected
            .bind(this);
        this.reset = this
            .reset
            .bind(this);

        this.onChange = this
            .onChange
            .bind(this);

    }

    componentDidMount() {
        Quagga.onDetected(this.onDetected);

    }
    componentWillUnmount() {
        Quagga.offDetected(this.onDetected);
    }

    reset(e) {
        e.preventDefault();
        const {orderId, workOrderActions, outlet} = this.props;
        workOrderActions.outletUpdate({
            orderId: orderId,
            newSerialNumber: outlet.get('originalSerialNumber'),
            outletId: outlet.get('equipmentOutlet')
        });
    }

    onChange(e) {
        const {workOrderActions, outlet, orderId} = this.props;

        workOrderActions.outletUpdate({
            orderId: orderId,
            possibleScanSerialNumbers: [],
            outletId: outlet.get('equipmentOutlet')
        });

        if (e.target.files && e.target.files.length) {
            const src = URL.createObjectURL(e.target.files[0]);

            Quagga.decodeSingle({
                inputStream: {
                    size: 800,
                    singleChannel: false
                },
                locator: {
                    patchSize: "medium",
                    halfSample: true
                },
                decoder: {
                    multiple: true,
                    readers: [
                        {
                            format: "code_128_reader",
                            config: {}
                        }
                    ]
                },
                locate: true,
                src: src
            }, () => {});
        }
    }

    onDetected(results) {

        const {workOrderActions, outlet, orderId} = this.props;

        const possibleSerialNumbers = [];

        if (results) {
            results.forEach((result) => {
                if (result.codeResult) {
                    possibleSerialNumbers.push(result.codeResult.code);
                }
            });
        }

        workOrderActions.outletUpdate({
            orderId: orderId,
            possibleScanSerialNumbers: possibleSerialNumbers,
            outletId: outlet.get('equipmentOutlet')
        });

        if (results && results.length === 1 && results[0].codeResult) {
            workOrderActions.outletUpdate({
                orderId: orderId,
                newSerialNumber: results[0].codeResult.code,
                outletId: outlet.get('equipmentOutlet')
            });
        }

    }

    render() {
        const {workOrderActions, outlet, orderId} = this.props;

        if (!outlet) {
            return null;
        }

        let possibleSerialRows = [];

        if (outlet.get('possibleScanSerialNumbers')) {
            possibleSerialRows = outlet
                .get('possibleScanSerialNumbers')
                .map((serial, index) => {
                    return (
                        <tr key={`possible_serial_${index}`}>
                            <td>{serial}</td>
                            <td>
                                <RaisedButton
                                    onTouchTap={(e) => {
                                    e.preventDefault();
                                    workOrderActions.outletUpdate({
                                        orderId: orderId,
                                        newSerialNumber: serial,
                                        outletId: outlet.get('equipmentOutlet')
                                    });
                                }}
                                    fullWidth
                                    primary
                                    label="Select"/></td>
                        </tr>
                    );
                });
        }

        let scanResults = (
            <div>
                <h5>Scan Results</h5>
                <table className="table">
                    <tbody>{possibleSerialRows}</tbody>
                </table>
            </div>
        );

        if (possibleSerialRows.length === 0) {
            scanResults = (
                <div>No Serial Numbers Found</div>
            );
        }

        if (possibleSerialRows.length === 1) {
            scanResults = null;
        }

        let currentDisplay = null,
            actionDisplay = null;

        if (outlet.get('action') === 'add' || outlet.get('action') === 'update' || outlet.get('action') === 'remove') {
            currentDisplay = (
                <div>
                    <label
                        style={{
                        paddingRight: '10px'
                    }}>
                        Current:
                    </label>
                    {outlet.get('originalSerialNumber') || 'None'}
                    <FlatButton primary label="Reset" onTouchTap={this.reset}/>
                    <br/>

                </div>
            );

            actionDisplay = (
                <div>
                    <label
                        style={{
                        paddingRight: '10px'
                    }}>
                        {outlet.get('action')}:
                    </label>
                    {outlet.get('seriaNumber')}
                    <br/>
                </div>
            );

        } else {
            currentDisplay = (
                <div>
                    <label
                        style={{
                        paddingRight: '10px'
                    }}>
                        Current:
                    </label>
                    {outlet.get('seriaNumber') || 'None'}
                    <br/>

                </div>
            );
        }

        return (
            <div>
                {currentDisplay}
                {actionDisplay}
                <input type="file" onChange={this.onChange} accept="image/*" capture="camera"/> {scanResults}
            </div>
        );
    }

}

Scanner.propTypes = {
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object,
    outlet: PropTypes.object
};

export default Scanner;



// WEBPACK FOOTER //
// ./src/components/equipment/Scanner.js